'use client';

import   MobileWrapper  from '@/components/shared/mobile-wrapper/mobile-wrapper.component';
import DesktopWrapper from '@/components/shared/desktop-wrapper/desktop-wrapper.component';
import Typography from '@/components/shared/typography/typography.component';
import Image from 'next/image';
import styles from './styles.module.scss';
// import { InfoCircleRed } from '../../../../public/Images';

interface IInspectionTypeMobile {
    id: string;
    header: string;
    subHeader: string;
    img: string;
    tag?: string;
    btnClick: (id: string) => void;
    selected: boolean;
    style?: any;
    enableWave?: boolean;
}

const InspectionButtonMobile = ({
    id,
    header,
    subHeader,
    img,
    tag,
    btnClick,
    selected,
    style,
    enableWave = false,
}: IInspectionTypeMobile) => {
    return (
        <button
            style={style}
            onClick={() => btnClick(id)}
            className={`${styles.button} ${selected ? styles.active : ''}`}
        >
            <div className={styles.content_container}>
                <div className={styles.image_container}>
                    {enableWave && <div className={styles.wave} />}
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            zIndex: '3',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Image src={img} alt={header} width={16} height={16} />
                    </div>
                </div>
                <div style={{ textAlign: 'start' }}>
                    <div className={styles.header_container}>
                        <DesktopWrapper>
                            <Typography
                                style={{
                                    width: 'fit-content',
                                    marginBottom: '4px',
                                }}
                                variant="subtitle2SemiBold"
                                color="#002D5D"
                            >
                                {header}
                            </Typography>
                        </DesktopWrapper>
                        <MobileWrapper>
                            <Typography
                                style={{
                                    width: 'fit-content',
                                    marginBottom: '4px',
                                }}
                                variant="captionSemiBold"
                                color="#002D5D"
                            >
                                {header}
                            </Typography>
                        </MobileWrapper>
                        {tag && (
                            <div className={styles.tag}>
                                <Typography
                                    variant={'captionMedium'}
                                    color="#BC1B06"
                                >
                                    {tag}
                                </Typography>
                            </div>
                        )}
                    </div>
                    <Typography
                        style={{ width: 'fit-content' }}
                        component="span"
                        variant="caption"
                        color="#4B5565"
                    >
                        {subHeader}
                    </Typography>
                </div>
            </div>
            <div
                className={`${styles.select_container} ${
                    selected ? styles.active : ''
                }`}
            >
                <div className={styles.select} />
            </div>

            {/* {tag && (
        <div className={styles.tag} dir={dir}>
          <Image
            src={InfoCircleRed.src}
            width={InfoCircleRed.width}
            height={InfoCircleRed.height}
            alt="info"
            className={styles.tag_img}
          />

          <Typography variant={IS_DESKTOP ? 'body1Medium' : 'captionMedium'} color="#BC1B06">
            {tag}
          </Typography>
          <Typography variant={'body1Medium'} color="#BC1B06">
            {tag}
          </Typography>
        </div>
      )} */}
        </button>
    );
};
export default InspectionButtonMobile;
